<template>
  <div class="practice">
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
    <div class="Navbar">
      <section class="hero is-white is-fullwidth" style="text-align:start">
        <div class="hero-body" style="border-bottom: medium solid #4a4a4a;">
          <div class="container">
            <h1 class="title">練習</h1>
            <h2 class="subtitle">プログラム同士を戦わせよう！</h2>
          </div>
        </div>
      </section>
    </div>
    <result />
    <section class="hero is-white">
      <div class="columns">
        <div class="column is-6">
          <h1>プレイヤー</h1>
          <br />
          <codemirror v-model="user_code" :options="cmOptions" style="text-align:start;"></codemirror>
        </div>

        <div class="column is-6">
          <nav class="level">
            <div class="level-left">
              <h1>対戦相手</h1>
            </div>
          </nav>
          <codemirror v-model="enemy_code" :options="cmOptions" style="text-align:start;"></codemirror>
          <br />
        </div>
      </div>

      <div class="columns">
        <a class="button is-primary is-large is-fullwidth" @click="postData">対戦</a>
      </div>

      <!-- <div v-if="items">
        <Result :items="items" :win="win" :lose="lose" :drow="drow" :jage="jage"></Result>
      </div>-->
    </section>
  </div>
</template>

<script>
const apiUrl =
  process.env.VUE_APP_DB_API;
const config = {
  headers: {
    "Content-Type": "application/json"
  }
};
import axios from "axios";
import { constants } from "crypto";
import { mapState } from "vuex";

import Result from "./Result";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/python/python.js";
import "codemirror/theme/mbo.css";
import "codemirror/addon/selection/active-line.js";
// closebrackets
import "codemirror/addon/edit/closebrackets.js";

export default {
  name: "Practice",
  data() {
    return {
      isLoading: false,
      cmOptions: {
        autoCloseBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        line: true,
        mode: "text/x-python",
        theme: "mbo"
      }
    };
  },

  computed: {
    user_code: {
      get() {
        return this.$store.state.user_code;
      },
      set(c) {
        this.$store.commit("setUserCode", c);
      }
    },
    enemy_code: {
      get() {
        return this.$store.state.enemy_code;
      },
      set(c) {
        this.$store.commit("setEnemyCode", c);
      }
    },
    jankenHistory: {
      get() {
        return this.$store.state.jankenHistory;
      },
      set(h) {
        this.$store.commit("setJankenHistory", h);
      }
    }
  },
  components: {
    Result
  },
  methods: {
    postData() {
      this.postLog = "データを送信しています";

      this.isLoading = true;
      this.$axios
        .post(apiUrl + "/practice", {
          enemy: this.enemy_code,
          player: this.user_code
        })
        .then(response => {
          this.jankenHistory = JSON.parse(response.data.body);
          console.table(this.jankenHistory);
        })
        .catch(reason => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "対戦に失敗しました。<br>プログラムを間違えていませんか？",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        })
        .finally(reason => {
          this.isLoading = false;
        });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin-top: 20px;
  font-size: 30px;
  text-align: left;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
